import {
  ACTIVE_SET_FILTERS,
  ACTIVE_CLEAR_FILTERS,
  ACTIVE_SET_PAGE,
  ACTIVE_SET_PAGE_SIZE,
  ACTIVE_SET_SEARCH,
  ACTIVE_SET_SORT,
  ACTIVE_FETCH_REQUEST,
  ACTIVE_FETCH_SUCCESS,
  ACTIVE_FETCH_FAILURE,
} from '../actions/actionTypes';
import { ActiveAction } from '../actions/activeActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface ActiveState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: ActiveState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function activeReducer(
  state: ActiveState = initialState,
  action: ActiveAction,
): ActiveState {
  switch (action.type) {
    case ACTIVE_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case ACTIVE_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case ACTIVE_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case ACTIVE_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case ACTIVE_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case ACTIVE_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case ACTIVE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case ACTIVE_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case ACTIVE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
